import Icon from '@mdi/react';
import { mdiFileWordOutline, mdiFilePdfOutline, mdiFolderZipOutline, mdiFilePowerpointOutline, mdiFileOutline } from '@mdi/js';
import { useEffect, useState } from 'react';
import { IApiMediaWithCropsModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import { removeTimeFromStringDateTime } from '@shared/utils/dateUtils.ts';

interface IFileLink {
    title?: string | null;
    validFrom?: string | null;
    validTo?: string | null;
    contract?: IApiMediaWithCropsModel[] | null;
}
const ContractFileLink = ({ title, validFrom, validTo, contract }: IFileLink) => {
    const [file, setFile] = useState<IApiMediaWithCropsModel | null>(null);
    useEffect(() => {
        if (!contract || !contract[0]) return;

        setFile(contract[0]);
    }, [contract]);
    if (!file) return <></>;
    return (
        <div className='click-item  click-item--hover mb-3'>
            <a
                href={file.url}
                className='link-icon contract-list-item'
                target='_blank'
                rel='noreferrer'
            >
                <div className='contract-list-item__title-wrapper'>
                    <div className='icon-round icon-round-sm mr-3'>
                        <Icon
                            path={FileLinkMDILogo(file?.extension)}
                            className='mdi'
                        />
                    </div>
                    <div className='contract-list-item__title'>{`${title} (${file.extension})`}</div>
                </div>
                {(validFrom || validTo) && (
                    <div className='contract-list-item__valid-title'>
                        <div>
                            <i>Giltighetstid</i>
                        </div>
                        {validFrom && <div>fr.o.m. {removeTimeFromStringDateTime(validFrom)}</div>}
                        {validTo && <div>t.o.m. {removeTimeFromStringDateTime(validTo)}</div>}
                    </div>
                )}
            </a>
        </div>
    );
};

const FileLinkMDILogo = (fileExtension?: string | null) => {
    if (fileExtension === 'docx' || fileExtension === 'doc') {
        return mdiFileWordOutline;
    } else if (fileExtension === 'pdf') {
        return mdiFilePdfOutline;
    } else if (fileExtension === 'rar' || fileExtension === 'zip') {
        return mdiFolderZipOutline;
    } else if (fileExtension === 'pptx') {
        return mdiFilePowerpointOutline;
    } else {
        return mdiFileOutline;
    }
};

export default ContractFileLink;
